/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import Button from "@atlaskit/button";
import React, { ReactElement, useEffect, useState } from "react";
import TimeSlotDay, {
    TimeSlotsDay,
} from "../../components/TimeSlotDay/TimeSlotDay";
import { MessageContext } from "../../contexts/Message/MessageContext";
import API from "../../services/API";
import { Booking } from "../../types/Booking/Booking";
import "./WorkingTimeSlots.scss";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

export default function WorkingTimeSlots({}: Props): ReactElement {
    const messageContext = React.useContext(MessageContext);
    const [workingTimes, setWorkingTime] = useState<TimeSlotsDay[]>(
        [
            {
                day: 1,
                dayLabel: "Montag",
            },
            {
                day: 2,
                dayLabel: "Dienstag",
            },
            {
                dayLabel: "Mittwoch",
                day: 3,
            },
            {
                dayLabel: "Donnerstag",
                day: 4,
            },
            {
                dayLabel: "Freitag",
                day: 5,
            },
            {
                dayLabel: "Samstag",
                day: 6,
            },
            {
                dayLabel: "Sonntag",
                day: 0,
            },
        ].map((day) => ({
            ...day,
            dayEnabled: false,
            startTime: undefined,
            endTime: undefined,
            isChanged: false,
        }))
    );

    useEffect(() => {
        API.HandleGetRequest<Booking.WorkingTimeSlot[]>(
            "/working_time_slots"
        ).then((response) => {
            const newSlots = [...workingTimes];
            response.forEach((timeSlot) => {
                const index = newSlots.findIndex(
                    (el) => el.day === timeSlot.day
                );
                // eslint-disable-next-line no-magic-numbers
                if (index !== -1) {
                    newSlots[index] = {
                        ...newSlots[index],
                        endTime: timeSlot.endTime,
                        startTime: timeSlot.startTime,
                        dayEnabled: true,
                        id: timeSlot.id,
                    };
                }
            });
            setWorkingTime(newSlots);
        });
    }, []);
    const cantBeSaved = () => {
        messageContext.actions.setMessage({
            title: "Bitte füllen sie alle Felder für die ausgewählten Tage aus",
            isOpen: true,
            titleApparencce: "warning",
            buttons: [
                {
                    buttonText: "OK",
                    onClick: () => messageContext.actions.closeModal(),
                },
            ],
        });
    };
    const save = async () => {
        let canBeSaved = true;
        // validation
        workingTimes.forEach((slot) => {
            if (slot.dayEnabled) {
                if (!slot.endTime || !slot.startTime) {
                    canBeSaved = false;
                }
            }
        });

        if (!canBeSaved) {
            return cantBeSaved();
        }

        const promises: Promise<Booking.WorkingTimeSlot>[] = [];
        workingTimes
            .filter((day) => day.isChanged && day.dayEnabled)
            .forEach((slot) => {
                if (slot.startTime && slot.endTime) {
                    promises.push(
                        API.handlePostRequest<
                            Booking.WorkingTimeSlotDto,
                            Booking.WorkingTimeSlot
                        >(
                            {
                                day: slot.day,

                                startTime: slot.startTime,

                                endTime: slot.endTime,

                                offset: new Date().getTimezoneOffset(),
                            },
                            "/working_time_slots"
                        )
                    );
                }
            });
        // delete not enabled days
        workingTimes
            .filter((day) => day.isChanged && !day.dayEnabled)
            .forEach((slot) => {
                if (slot.id) {
                    promises.push(
                        API.handleDeleteRequest<null, Booking.WorkingTimeSlot>(
                            null,
                            `/working_time_slots/${slot.id}`
                        )
                    );
                }
            });
        await Promise.all(promises);

        // change isChanged to fale in state
        API.HandleGetRequest<Booking.WorkingTimeSlot[]>(
            "/working_time_slots"
        ).then((response) => {
            const newSlots = [...workingTimes];
            response.forEach((timeSlot) => {
                const index = newSlots.findIndex(
                    (el) => el.day === timeSlot.day
                );
                // eslint-disable-next-line no-magic-numbers
                if (index !== -1) {
                    newSlots[index] = {
                        ...newSlots[index],
                        endTime: timeSlot.endTime,
                        startTime: timeSlot.startTime,
                        dayEnabled: true,
                        id: timeSlot.id,
                    };
                }
            });
            setWorkingTime(
                newSlots.map((slot) => ({
                    ...slot,
                    isChanged: false,
                }))
            );
        });
        return true;
        // change all changed to non changed
    };
    const changeTimeSlot = (index: number, change: Partial<TimeSlotsDay>) => {
        const newSlots = [...workingTimes];
        let isChanged = true;
        if (!change.dayEnabled && newSlots[index].dayEnabled === false) {
            isChanged = false;
        }
        if (change.dayEnabled === false) {
            change.startTime = undefined;
            change.endTime = undefined;
        }
        newSlots[index] = {
            ...newSlots[index],
            ...change,
            isChanged,
        };
        setWorkingTime(newSlots);
    };
    return (
        <div className="working-time-slot-container">
            <div className="working-time-slots">
                {workingTimes.map((workingTime, index) => (
                    <TimeSlotDay
                        key={index}
                        index={index}
                        onChange={changeTimeSlot}
                        time={workingTime}
                    />
                ))}
            </div>
            {
                <div className="working-time-button">
                    <Button
                        isDisabled={
                            !(
                                workingTimes.filter(
                                    (workingTime) =>
                                        workingTime.isChanged === true
                                ).length > 0
                            )
                        }
                        appearance="primary"
                        onClick={save}
                    >
                        Save
                    </Button>
                </div>
            }
        </div>
    );
}
